import { isVue2 } from "vue-demi";
export default function universalProvide(app, provideKey, options) {
  if (isVue2) {
    app.mixin({
      beforeCreate() {
        if (!this._provided) {
          const provideCache = {};
          Object.defineProperty(this, "_provided", {
            get: () => provideCache,
            set: (v) => Object.assign(provideCache, v)
          });
        }
        this._provided[provideKey] = options;
      }
    });
  } else {
    app.provide(provideKey, options);
  }
}
